module.exports = __webpack_public_path__ + "static/media/hiper_black.a43bccfd.png";